module.exports = __webpack_public_path__ + "img/menu-icon-1-4.833f5348.svg";